import { styled } from '@mui/material/styles';

import { ACTION_BUTTON_CLASSNAME } from 'pages/ParentHelper/components/History/components/Content/components/ChatTopic/constants';
import { ChatTopicWrapper } from 'pages/ParentHelper/components/History/components/Content/components/ChatTopicWrapper';

export const Wrapper = styled(ChatTopicWrapper)(({ theme }) => ({
  transition: theme.transitions.create('background-color', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginTop: theme.spacing(0.5),

  [theme.breakpoints.up('md')]: {
    marginTop: theme.spacing(1),

    [`& .${ACTION_BUTTON_CLASSNAME}`]: {
      maxWidth: 0,
      padding: 0,
      overflow: 'hidden',
    },

    '&:hover': {
      [`& .${ACTION_BUTTON_CLASSNAME}`]: {
        maxWidth: '100px',
        padding: theme.spacing(1),
      },
    },
  },
}));
